import axios from 'axios';
import * as Config from '../../config';

const state = { };

const actions = {
    // Mono: Adherir a servicio "Mis Comprobantes"
    delegate_monotributistaAdherirMisComprobantes({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'delegate/monotributista-adherir-mis-comprobantes', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    // Mono: Adherir servicio CCMA
    delegate_monotributistaAdherirCcma({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'delegate/monotributista-adherir-ccma', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    // Mono: Delegar Facturacion Electronica
    delegate_monotributistaDelegate({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'delegate/monotributista-delegate', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    // Represented: Aceptar delegacion (facturacion electronica)
    delegate_representativeAcceptRepresented({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'delegate/representative-accept-represented', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    // Mono: Delegar e-ventanilla
    delegate_monotributistaDelegateEventanilla({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'delegate/monotributista-delegate-eventanilla', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    // Represented: Aceptar delegacion (e-ventanilla)
    delegate_representativeAcceptRepresentedEventanilla({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'delegate/representative-accept-represented-eventanilla', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    // Derivar relacion facturacion electronica al computador fiscal
    delegate_relationFiscalComputer({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'delegate/relation-fiscal-computer', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    // Derivar relacion e-ventanilla al computador fiscal
    delegate_relationFiscalComputerEventanilla({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'delegate/relation-fiscal-computer-eventanilla', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    // Mono: adherir punto de venta
    delegate_accessionAbmPuntoVenta({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'delegate/accession-abm-punto-venta', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    // Mono: Crear punto de venta
    delegate_electronicBilling({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'delegate/electronic-billing', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    delegate_getLogsRegistroByIdMono({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'delegate/get-logs-registro-by-id-mono', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    }
}

const mutations = {

};

export default {
    state,
    actions,
    mutations
};